import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CaseService } from './case.service';
import { RegistrarService } from './registrar.service';
import { AdminService } from './admin.service';
import { JudgeService } from './judge.service';

/**
 * Supplies live counts for sidebar nav badges, keyed by the nav item's
 * route (e.g. 'cases', 'queue', 'users'). The portal shell subscribes to
 * counts$ and overlays these onto the static nav config, so a wired route
 * shows the real number while unwired ones keep their placeholder badge.
 */
@Injectable({ providedIn: 'root' })
export class NavCountsService {
  private counts = new BehaviorSubject<Record<string, number>>({});
  counts$ = this.counts.asObservable();

  constructor(
    private caseService: CaseService,
    private registrarService: RegistrarService,
    private adminService: AdminService,
    private judgeService: JudgeService,
  ) {}

  private patch(route: string, n: number) {
    this.counts.next({ ...this.counts.value, [route]: n });
  }

  /** Fetch the count(s) relevant to the given portal role. Failures are ignored. */
  loadFor(role: string) {
    switch ((role ?? '').toLowerCase()) {
      case 'citizen':
        this.caseService.getCases(1, 1).subscribe({
          next: (res) => this.patch('cases', res.totalCount),
          error: () => {},
        });
        break;
      case 'registrar':
        this.registrarService.getQueue('all').subscribe({
          next: (items) => this.patch('queue', items.total),
          error: () => {},
        });
        break;
      case 'admin':
        this.adminService.getUsers(1, 1).subscribe({
          next: (res) => this.patch('users', res.totalCount),
          error: () => {},
        });
        break;
      case 'judge':
        this.judgeService.getCases(1, 1).subscribe({
          next: (res) => this.patch('cases', res.totalCount),
          error: () => {},
        });
        break;
    }
  }
}
